export const appConfig = {
    //PROD
    APP_VERSION:'2.10.51_build_2',
    WEB_URL:'https://givesome.org',
    WEB_BASE_PATH:'/payweb',
    API_URL:'https://api.givesome.gives',
    STRIPE_PUBLIC_KEY: 'pk_live_AQLxo4SlqpcVyBZnpOXJ2g5V',
    SAVED_PAYMENT: "https://givesome.org/stripe/customer/saved-payments/"
     //DEV
//     APP_VERSION:'2.10.51_build_2',
//     WEB_URL:'https://qa.givesome.org',
//     WEB_BASE_PATH:'/payweb',
//    // API_URL:'https://qa-api.givesome.gives',
//     API_URL:'http://localhost:8080',
//     SAVED_PAYMENT: "https://qa.givesome.org/stripe/customer/saved-payments/",
//     STRIPE_PUBLIC_KEY: 'pk_test_iCtGespAG6juRKtu3MutGj6Q',
//     STRIPE_SECRET_KEY: 'sk_test_FmAxDmTqda9jAkQrFdx4r2Ac'
}